import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { TransparentDialogWrapper } from "../../transparent-dialog/TransparentDialogWrapper";
import { BigCharacter } from "../big-character/BigCharacter";
import { TextLoca } from "../text/TextLoca";
export var DialogFarmEvent = function (_a) {
    var eventTitleLoca = _a.eventTitleLoca, eventCharacter = _a.eventCharacter, eventCharacterClassName = _a.eventCharacterClassName, eventDescriptionLoca = _a.eventDescriptionLoca, _b = _a.eventDescriptionStyleId, eventDescriptionStyleId = _b === void 0 ? IdStyles.TraderBubbleContainer : _b, children = _a.children;
    return (React.createElement("div", { className: "farm-events__overlay" },
        React.createElement(TransparentDialogWrapper, null,
            React.createElement("div", { className: "flex padding--large" },
                React.createElement(BigCharacter, { className: eventCharacterClassName, name: eventCharacter }),
                React.createElement("div", { className: "flex flex--stacked__reverse flex--guts" },
                    children,
                    React.createElement("div", { className: eventDescriptionStyleId + " speech-bubble flex__align-start" },
                        React.createElement("div", { className: IdStyles.TextBoldAccent },
                            React.createElement(TextLoca, { id: eventTitleLoca })),
                        React.createElement("div", { className: IdStyles.TextNormal },
                            React.createElement(TextLoca, { id: eventDescriptionLoca }))))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/farm-event/DialogFarmEvent.tsx
// module id = 436
// module chunks = 3